/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m12 10.071 3.9701 3.9544.1046.0871a.75.75 0 0 0 .9556-1.1482c.0004.0003-.0003-.0003 0 0l-.0011-.0011L12 7.9532l-5.0293 5.01-.087.1038a.7501.7501 0 0 0 .085.9569l.1037.087a.7502.7502 0 0 0 .9559-.0839c-.0004.0003.0003-.0004 0 0L12 10.071ZM12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Zm0 1.5C5.3726 24 0 18.6274 0 12S5.3726 0 12 0s12 5.3726 12 12-5.3726 12-12 12Z"
    clipRule="evenodd"
  />,
  'ExpandLess'
);
